module.exports = __webpack_public_path__ + "img/huize.237e460c.png";